<template>
  <div class="content">
    <van-nav-bar title="我的银行卡" @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" src="../../../assets/right_icon2.png" alt="">
      </template>
            <template #right>
              <img style="width: 4.93333vw;height: auto;display: inline-block;" src="../../../assets/card_home.png" alt="">
            </template>
    </van-nav-bar>
    <div class="card-list">
      <div class="item-box" v-for="(item,index) in list" :key="index">
        <div class="card-name">{{item.bank_name}}</div>
        <div class="card-num">{{item.bank_number}}</div>
        <div class="bottom-box justify-align">
          <div class="box-lf left-justifying">
            <div class="active-box" @click="clickSetDefaultActive(item.id,index)" v-if="item.is_default == 1"><img src="../../../assets/qb_arrow.png" alt="" /></div>
           <div class="default-box" @click="clickSetDefault(item.id,index)" v-else></div>
            设为默认
          </div>
          <div class="del" @click="clickDel(item.id)">删除</div>
        </div>
      </div>

    </div>
    <div class="button-box content-center" @click="addCard">
      <img src="../../../assets/add_card.png" alt="" />添加银行卡
    </div>
  </div>
</template>

<script>
import {setRemove, getWalletBank,setDefault} from '@/api/wallet'

export default {
  name: "myCard",
  data() {
    return {
      username: '',
      password: '',
      tel: '',
      sms: '',
      radio: '1',
      list: []
    };
  },
  beforeCreate: function() {
    // console.log('1')
    window.document.body.style.backgroundColor= '#fff'
  },
  beforeDestroy: function() {
    // console.log('2')
    window.document.body.style.backgroundColor= ''
  },
  created() {
    this.getBankList()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push('/');
    },
    clickDel(id){
      setRemove(id).then(res => {
        if(res.code == 200)
        {
          this.$toast(res.message)
          setTimeout(() => {
            this.getBankList()
          }, 1500)
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    clickSetDefaultActive(id,index){ // 去掉默认
      var list = this.list
      list[index].is_default= !list[index].is_default
      this.list = list
      setDefault(id).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          // this.list = []
          // that.getBankList()
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    clickSetDefault(id,index){ // 设置为默认
      var that = this
      // console.log('id',id)
      // console.log('index',index)

      var list = this.list

      list.map((item, k) => {
        if (index == k){
          item.is_default = 1
        } else {
          item.is_default = 0

        }
      })
      this.list = list
      setDefault(id).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          // this.list = []
          // that.getBankList()
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    getBankList(){
      getWalletBank().then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          this.list = res.data
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    addCard(values) {
      console.log('submit', values);
      this.$router.push('/bindingCard');
    },
  }
}
</script>

<style lang="scss" scoped>
.default-box{
  width: 34px;
  height: 34px;
  border: 2px solid #FFFFFF;display: inline-block;
  border-radius: 50%;margin-right: 10px;
}
.active-box{
  width: 34px;background: #FFFFFF;border-radius: 50%;text-align: center;
  margin-right: 10px;border: 2px solid #FFFFFF;overflow: hidden;height: 34px;
  img{
    width:80%;height: auto;display: inline-block;
  }
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.card-list{
  font-size: 30px;
  width: 656px; margin: 41px auto;
  .item-box{
   color: #ffffff;padding: 30px 30px;text-align: left;
    background: linear-gradient(-90deg, #56BB3B 0%, #A3C040 100%);
    border-radius: 15px;margin-bottom: 25px;
    .card-name{
      font-size: 30px;padding-bottom: 38px;
    }
    .card-num{
      font-size: 30px;padding-bottom: 47px;
    }
  }
}
/deep/ .van-radio__label{
  color: #ffffff;
}
.button-box{

  width: 656px;
  padding: 25px;
  background: #FDD80D;
  border-radius: 15px;margin: 30px auto 0;font-size: 34px;font-weight: bold;
  color: #282828;
  img{
    width: 36px;height: auto;display: inline-block;margin-right: 10px;
  }
}

</style>
